import Text from '@/atoms/Text/Text';
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';
import RichText from '@/molecules/RichText/RichText';
import React from 'react'

function ColumnsTextBlock({  entries, fields }) {
  const { name, numberingSection, contentTitle1, contentNumber1, contentTitle2, contentNumber2, contentTitle3,  contentNumber3, contentTitle4, contentNumber4, contentTitle5, contentNumber5, textColor } = fields;
  const contents = [contentNumber1, contentNumber2, contentNumber3, contentNumber4, contentNumber5].filter(Boolean);
  const contentTitle = [contentTitle1, contentTitle2, contentTitle3, contentTitle4, contentTitle5].filter(Boolean);
  return (
    <div className="aaco-columns-text-block-wrapper grid gap-8 md:grid-cols-2">
      {contents.map((content, index) => {
        return (
          <div key={index} className="aaco-columns flex flex-col gap-4">
            {numberingSection && (
              <div className="columns-numbering">
                <Text
                  tag="caption"
                  style={`text-${textColor} border-l-1 border-l-${textColor} pl-4`}
                >
                  0{index + 1} <span className="pl-2">{contentTitle[index]}</span>
                </Text>
              </div>
            )}
            <div className="columns-content-text self-start grid gap-y-4">
              {content?.content?.map(({ content, nodeType }, idx) => {
                return (
                  <RichText
                    entries={entries}
                    content={content}
                    key={idx}
                    nodeType={nodeType}
                    richTextStyle={{
                      paragraph: {
                        customFont: TEXT_BASE_CLASS['body'] + ` text-${textColor}`,
                      },
                    }}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ColumnsTextBlock
